import VisibilityController from "../../../output/assets/objects/visibility-controller.js";

class ThreeVisibilityController extends VisibilityController {
    constructor() {
        super();
    }

    setVisible(object, visible) {
        object.visible = visible;
    }
}

export default ThreeVisibilityController;
